import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ProjectModel} from '../../project/project.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectListService {


  constructor(
    private http: HttpClient
  ) { }

  public getProjects(): Observable<ProjectModel[]> {
    const httpParams =
      (new HttpParams())
        .append('per-page', '1000')
        .append('page', '1')
        // .append('expand', 'custom_name')
        .append('fields', 'id, custom_name')
    ;
    return this.http.get<ProjectModel[]>(
      environment.apiBasepoint + 'project',
      {
        observe: 'body',
        params: httpParams
      }
    );
  }
}
